// サムネイルクリックでスライダー移動
function SlideToSwiper(swiper, thumbnail) {
  const INDEX = parseInt(thumbnail.dataset.index, 10) - 1;
  swiper.slideTo(INDEX);
}

// Swiper(モバイル)
const SWIPER_PRODUCT_DETAIL = document.querySelector("#swiper-product-detail-mobile");
const SWIPER_PRODUCT_DETAIL_SLIDES_LENGTH =
  SWIPER_PRODUCT_DETAIL.querySelectorAll(".swiper-slide").length;

new Swiper(SWIPER_PRODUCT_DETAIL, {
  loop: SWIPER_PRODUCT_DETAIL_SLIDES_LENGTH > 3, // ループ
  speed: 1500, // 少しゆっくり(デフォルトは300)
  slidesPerView: 1, // 一度に表示する枚数
  centeredSlides: true, // アクティブなスライドを中央にする
  // preventInteractionOnTransition: true,
  autoplay: {
    // 自動再生
    delay: 3000, // 1秒後に次のスライド
    disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

// Swiper(デスクトップ)
const SWIPER_PRODUCT_DETAIL_DESKTOP_MAIN = document.querySelector(
  "#swiper-product-detail-desktop-main",
);

const SWIPER_DESKTOP_MAIN = new Swiper(SWIPER_PRODUCT_DETAIL_DESKTOP_MAIN, {
  loop: true, // ループ
  speed: 1000, // 少しゆっくり(デフォルトは300)
  slidesPerView: 1, // 一度に表示する枚数

  navigation: {
    nextEl: ".swiper-with-thumbnail-main__next",
    prevEl: ".swiper-with-thumbnail-main__prev",
  },
});

// デスクトップ サムネイルクリックで移動
const PRODUCT_DETAIL_SWIPER_DESKTOP_THUMBNAIL_LIST = document.querySelectorAll(
  ".product-detail__swiper-desktop-thumbnail-item",
);
PRODUCT_DETAIL_SWIPER_DESKTOP_THUMBNAIL_LIST.forEach(function (thumbnail) {
  thumbnail.addEventListener("click", function () {
    SlideToSwiper(SWIPER_DESKTOP_MAIN, thumbnail);
  });
});

// ポップアップ
try {
  const PRODUCT_DETAIL_POPUP_BOTTON_OPEN = document.querySelector(
    "#product-detail-desktop-popup-button-open",
  );

  const PRODUCT_DETAIL_POPUP_BOTTON_CLOSE = document.querySelector(
    "#product-detail-desktop-popup-button-close",
  );

  // ポップアップの表示/非表示
  if (PRODUCT_DETAIL_POPUP_BOTTON_OPEN) {
    PRODUCT_DETAIL_POPUP_BOTTON_OPEN.addEventListener("click", function () {
      document.querySelector("html").classList.add("js-product-detail-popup-open");
    });
  }

  PRODUCT_DETAIL_POPUP_BOTTON_CLOSE.addEventListener("click", function () {
    document.querySelector("html").classList.remove("js-product-detail-popup-open");
  });

  // ポップアップ スライダー
  const SWIPER_PRODUCT_DETAIL_POPUP_MAIN = document.querySelector(
    "#swiper-product-detail-popup-main",
  );
  const SWIPER_POPUP_MAIN = new Swiper(SWIPER_PRODUCT_DETAIL_POPUP_MAIN, {
    loop: true, // ループ
    speed: 1000, // 少しゆっくり(デフォルトは300)
    slidesPerView: 1, // 一度に表示する枚数

    navigation: {
      nextEl: ".swiper-with-thumbnail-main__next",
      prevEl: ".swiper-with-thumbnail-main__prev",
    },
  });

  // ポップアップ サムネイルクリックで移動
  const POPUP_THUMBNAIL_LIST = document.querySelectorAll(".product-detail-popup__item");
  POPUP_THUMBNAIL_LIST.forEach(function (thumbnail) {
    thumbnail.addEventListener("click", function () {
      SlideToSwiper(SWIPER_POPUP_MAIN, thumbnail);
    });
  });
} catch (error) {
  console.log(error);
}
